module.exports = __webpack_public_path__ + "static/img/yeswecan0039.2f64ea1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0039.png
// module id = 614
// module chunks = 1